import { createSlice } from '@reduxjs/toolkit';
import api from '../Components/_helpers/api';

export const fseSlice = createSlice({
  name: 'fse',
  initialState: {
    data: {items: [], recordsTotal: 0},
    currentFilters: {},
    isLoading: true,
    error: '',
  },
  reducers: {
    requestDTEs: (state, action) => {
      state.isLoading = true;
      state.currentFilters = action.payload;
    },
    requestDTEsSuccess: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    requestDTEsFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    setError: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const { requestDTEs, requestDTEsSuccess, requestDTEsFailure, setError } = fseSlice.actions;

//Thunks
export const requestDTEsAsync = (payload) => (dispatch) => {
  let filters = payload || {};
  dispatch(requestDTEs(filters));

  api.post('/FSE/DTE', payload).then((data) => {
    dispatch(requestDTEsSuccess(data.data));
  }).catch(e => {
    console.log(e);
    dispatch(requestDTEsFailure(e));
  });
};

//Selector
export const selectData = (state) => state.fse.data;
export const selectIsLoading = (state) => state.fse.isLoading;
export const selectError = (state) => state.fse.error;
export const selectCurrentFilters = (state) => state.fse.currentFilters;

export default fseSlice.reducer;
